<script lang="ts" module>
  export const signedOutModal = new ModalState('signedOut');
</script>

<script lang="ts">
  import Close from '~icons/mdi/close';
  import ActionButton from '~/components/ActionButton.svelte';
  import Modal from '~/components/Modal.svelte';
  import { signinMutation } from './mutations.svelte';
  import { ModalState } from '~/lib/nav.svelte';
  import { signModal } from './Signin.svelte';
  import LogInIcon from '~icons/feather/log-in';
  import LogOutIcon from '~icons/feather/log-out';
  import { signedOut } from './AccountModal.svelte';

  const signin = signinMutation();

  const handleClose = () => {
    signedOut.current = true;
    signin.reset();
    signedOutModal.pop(true);
  };

  const handleLogin = () => {
    signedOut.current = true;
    signModal.push('in');
  };
</script>

<Modal anchor="body" open={signedOutModal.open} onClose={handleClose} index={6}>
  {#snippet title()}
    <LogOutIcon />Logged out
  {/snippet}
  {#snippet content()}
    You have been logged out
  {/snippet}
  {#snippet controls()}
    <ActionButton onClick={handleClose}>
      <Close />Close
    </ActionButton>
    <ActionButton onClick={handleLogin}><LogInIcon />Log in</ActionButton>
  {/snippet}
</Modal>
